import React, { FC, useCallback } from "react";
import { ThreepidSource, UserDetails } from "@dewo/app/graphql/types";
import {
  getThreepidName,
  ThreepidAuthButton,
} from "@dewo/app/containers/auth/buttons/ThreepidAuthButton";
import { useAuthWithMetamask } from "@dewo/app/containers/auth/hooks";
import { useRunning } from "@dewo/app/util/hooks";
import { ButtonProps } from "antd";
import { MetamaskIcon } from "@dewo/app/components/icons/Metamask";
import { useRouter } from "next/router";
import { useProvider } from "@dewo/app/util/ethereum";

interface Props extends ButtonProps {
  redirect?: string;
  onAuthed?(user: UserDetails): void;
}

export const MetamaskAuthButton: FC<Props> = ({
  redirect,
  onAuthed,
  ...buttonProps
}) => {
  const router = useRouter();
  const authWithMetamask = useAuthWithMetamask();
  const [auth, authing] = useRunning(
    useCallback(async () => {
      try {
        const user = await authWithMetamask();
        onAuthed?.(user);
        if (!!redirect) router.push(redirect);
      } catch (error) {
        alert((error as Error).message);
        throw error;
      }
    }, [authWithMetamask, onAuthed, router, redirect])
  );

  const { available } = useProvider();
  if (!available) return null;
  return (
    <ThreepidAuthButton
      loading={authing}
      source={ThreepidSource.metamask}
      children={getThreepidName[ThreepidSource.metamask]}
      redirect={redirect}
      icon={<MetamaskIcon />}
      onClick={auth}
      {...buttonProps}
    />
  );
};
